module.exports = __webpack_public_path__ + "static/img/rank_background_official.bc0172f7.png";